import { IPagedQuery } from './paginate';
import * as actionTypeProfile from '../../models/action/profile';
import { UploadRelationType } from '../enums/UploadRelationType';

export interface IPageProps {
    history?: any;
    location?: any;
    match?: any;
    dispatch?: any;
}

export interface IFileView {
    fileId: string;
    fileName: string;
    contentType: string;
    filePath: string;
    size: number;
    activityId: string;
    activityName: string;
    parentCourseId: string;
    week: string;
    createdDate: string;
    uploadRelationType: UploadRelationType;
    fullName: string | null;
}

export interface IFileListPageProps extends IPageProps {
    results?: IFileView[];
    filters?: IPagedQuery;
    coursePageClassId?: string;
    userPreferences?: actionTypeProfile.IPreference[];
    userType?: any;
    coursePageActivityId?: string;
    isWeekly?: boolean
}
export interface IFileListPageState {
    filters: IPagedQuery;
    history: IFileView[];
    showNewDirModal: boolean;
    model: IFileView;
    session_id?: string;
    base_dir_id?: string;
    selectedUploadRelationType: any;
    selectedUploadName: any;
    isSearchBoxOpen: boolean;
    isSearchBoxShow: boolean;
}

export const FileInitialValues: IFileView = {
    fileId: '',
    fileName: '',
    contentType: '',
    filePath: '',
    size: 0,
    activityId: '',
    activityName: '',
    parentCourseId: '',
    week: '',
    createdDate: '',
    uploadRelationType: 0,
    fullName: ''
};

export const FilterInitialValues: IPagedQuery = {
    orderBy: '',
    page: 1,
    take: 10,
    query: '',
    skip: 0,
    total: -1
};
